export class Apis {
    static baseUrl = 'https://pickeatnow.com';
    // static appleAuth = '/v1/members/apple/auth';
    // static googleAuth = '/v1/members/google/auth';
    static getMy = '/api/v1/user/my';
}